import Vue from "vue";
import { bus } from "@/main";
import get from "lodash/get";

export default {
	data() {
		return {
			loadImage: false,
			url: null,
			size: null,
			fullScreen: false
		}
	},
	props:[
		"source",
		"caption",
		"wordpress",
		"canFullScreen",
		"index",
	],
	created() {
		window.addEventListener("resize", () => {
			if(this.wordpress)
				this.evalSize();
		})
	},
	mounted() {
		this.lazyLoad();
		if(this.wordpress)
			this.evalSize();
	},
	watch: {
		"fullScreen" : () => {
			setTimeout(() => {
				this.evalSize();
			}, 200);
		}
	},
	methods: {
		evalSize() {
			let elementWidth = this.$el.parentElement.offsetWidth;
			let elementHeight = this.$el.parentElement.offsetHeight;
			
			let sizes = {
				huge: 1440,
				great: 1024,
				large: 768,
				medium: 320,
			};
			
			let widthHeightRatio = 3;
			
			let size = this.size

			if (elementWidth > sizes.huge || elementHeight > sizes.huge / widthHeightRatio) {
				size = "original";
			} else if (
				this.size !== "original" &&
				(elementWidth > sizes.great || elementHeight > sizes.great / widthHeightRatio)
			) {
				size = "huge";
			} else if (
				this.size !== "huge" &&
				this.size !== "original" &&
				(elementWidth > sizes.large || elementHeight > sizes.large / widthHeightRatio)
			) {
				size = "great";
			} else if (
				this.size !== "great" &&
				this.size !== "huge" &&
				this.size !== "original" &&
				(elementWidth > sizes.medium || elementHeight > sizes.medium / widthHeightRatio)
			) {
				size = "large";
			} else if (
				this.size !== "large" &&
				this.size !== "great" &&
				this.size !== "huge" &&
				this.size !== "original" &&
				elementWidth > 0
			) {
				size = "medium";
			}
			if (get(this.source, `sizes[${size}]`) == null) {
				size = "original";
			}

			this.size = size;

			this.url = this.source.sizes[size];
		},
		lazyLoad() {
			if ('IntersectionObserver' in window) {
				const image = this.$el;

				const options = {
					// If the image gets within 50px in the Y axis, start the download.
					root: null, // Page as root
					rootMargin: '0px',
					threshold: 0.1
				};
				
				const handleIntersection = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.intersectionRatio > 0) {
							this.loadImage = true;
						}
					})
				}

				const observer = new IntersectionObserver(handleIntersection, options);
				
				observer.observe(image);
			
			} else {
				this.loadImage = true
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/image/image.block.js